export const getEnv = () => window.EVOLVE_ENV;
export const getPrettyRegion = () => window.EVOLVE_REGION_PRETTY;
export const showRegionPage = () => window.EVOLVE_PAGE === 'region';
export const showCookiePolicyPage = () => window.EVOLVE_PAGE === 'cookie-policy';
export const showLoginPage = () => window.EVOLVE_PAGE === 'login';
export const showInternalLoginErrorPage = () => window.EVOLVE_PAGE === 'login-error';
export const showInternalOnboardingPage = () => window.EVOLVE_PAGE === 'onboarding-internal';
export const showExternalOnboardingPage = () => window.EVOLVE_PAGE === 'onboarding-external';
export const showSympricotPage = () => window.EVOLVE_PAGE === 'sympricot';
export const showStaffPage = () => window.EVOLVE_PAGE === 'staff';
export const showStaffErrorPage = () => window.EVOLVE_PAGE === 'staff-error';

export const generateCustomerIdCache = (
	uetr,
	uniqueFXReferenceNumber,
	paymentDirection,
	custId
) => {
	let custIdList = [];
	if (paymentDirection && uetr) {
		var customerIdObj = {
			paymentId: uetr,
			custId: custId
		};
		custIdList.push(customerIdObj);
	} else if (uniqueFXReferenceNumber) {
		uniqueFXReferenceNumber.split(',').forEach(paymentId => {
			var customerIdObj = {
				paymentId: paymentId,
				custId: custId
			};
			custIdList.push(customerIdObj);
		});
	}
	return JSON.stringify(custIdList);
};

export const getLoginSuccessUrl = (
	uetr,
	uniqueFXReferenceNumber,
	paymentDirection,
	hostname,
	protocol
) => {
	if (paymentDirection && uetr) {
		return (
			protocol +
			'//' +
			hostname +
			'/welcome/login-success?uniqueFXReferenceNumber=' +
			uetr +
			'&PaymentDirection=' +
			paymentDirection
		);
	} else {
		return (
			protocol +
			'//' +
			hostname +
			'/welcome/login-success?uniqueFXReferenceNumber=' +
			uniqueFXReferenceNumber +
			'&PaymentDirection=' +
			paymentDirection
		);
	}
};

export const getRedirectIdrUrl = (protocol, hostname, pathname, search) => {
	let idrHost = hostname.replace('.hk.', '.id.');
	return protocol + '//' + idrHost + pathname + search;
};
